export const initialState = {
  users: [],
  error: false,
  loading: false,
  isEdit: false,
};
